const PageHeader = ({ title, description, icon: Icon, actions }) => (
  <div className="flex flex-wrap items-start justify-between gap-4">
    <div className="space-y-2">
      <div className="flex items-center gap-3">
        {Icon ? <Icon size={28} className="text-primary" /> : null}
        <h2 className="text-xl font-medium text-primary">{title}</h2>
      </div>
      {description ? <p className="text-sm">{description}</p> : null}
    </div>
    {actions ? (
      <div className="flex flex-col items-end gap-1">{actions}</div>
    ) : null}
  </div>
);

export default PageHeader;
